/**
 * @generated SignedSource<<0527b4b6d101fb4366259df48e294730>>
 * @relayHash 22c6f89fc6c9ab30b22ca4d05d7d7057
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 22c6f89fc6c9ab30b22ca4d05d7d7057

import { ConcreteRequest } from 'relay-runtime';
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type useChatAvailabilityQuery$variables = Record<PropertyKey, never>;
export type useChatAvailabilityQuery$data = {
  readonly chatAvailability: ReadonlyArray<{
    readonly canCreateAdministrativeChats: boolean;
    readonly canCreateMedicalChats: boolean;
    readonly id: string;
    readonly language: Language;
  }>;
};
export type useChatAvailabilityQuery = {
  response: useChatAvailabilityQuery$data;
  variables: useChatAvailabilityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ChatStatus",
    "kind": "LinkedField",
    "name": "chatAvailability",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "language",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "canCreateMedicalChats",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "canCreateAdministrativeChats",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useChatAvailabilityQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useChatAvailabilityQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "id": "22c6f89fc6c9ab30b22ca4d05d7d7057",
    "metadata": {},
    "name": "useChatAvailabilityQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0b2c4f5e272c7f92850924e93524fcfa";

export default node;
